import { Helmet } from 'react-helmet'
import React from 'react'
import { useAppSelector } from '../../state/hooks'

export default function ItemSeo({ seo, restaurantSlug, itemSlug }) {
	const convertToTitleCase = str => {
		return str.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
	}

	const { loadedData } = useAppSelector(state => state.data)
	const orgName = loadedData[global.org]?.name || 'Restaurant'
	const restaurantName = restaurantSlug ? convertToTitleCase(restaurantSlug) : null

	const title = seo?.metaTitle ? seo.metaTitle : `${restaurantName} - Menu Item | ${orgName}`
	const description = seo?.metaDescription
		? seo.metaDescription
		: restaurantName
			? `View menu item details at ${restaurantName} - ${orgName}`
			: `View menu item details at ${orgName}`
	const orgURL = loadedData[global.org].webURL
		? loadedData[global.org].webURL.replace(/^(http:\/\/|https:\/\/)/, '')
		: ''

	const canonicalUrl = `${orgURL}/menu/${restaurantSlug}/${itemSlug}`

	return (
		<Helmet>
			{/* Basic Meta Tags */}
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta charSet="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
			<link rel="canonical" href={canonicalUrl} />

			{/* Open Graph Meta Tags */}
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:type" content="website" />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:site_name" content={orgName} />

			{/* Twitter Card Meta Tags */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />

			{/* Additional Meta Tags */}
			<meta name="robots" content="index, follow" />
			<meta name="theme-color" content="#ffffff" />
			<meta name="mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-status-bar-style" content="default" />
			<meta name="apple-mobile-web-app-title" content={orgName} />
		</Helmet>
	)
}
